// @flow
import * as React from 'react';
import { Button } from '@locus-taxy/neo-ui';
export class ButtonOverride extends React.PureComponent<
    React.ElementConfig<typeof Button>
> {
    render() {
        return (
            <Button
                {...this.props}
                sx={{
                    height: '36px',
                    width: '36px',
                    padding: 0,
                    i: {
                        fontSize: '24px'
                    }
                }}
            />
        );
    }
}
